"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageWidget = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const styled_components_1 = __importDefault(require("styled-components"));
const components_2 = require("../..");
const Charts_1 = require("../../Charts");
const components_3 = require("../components");
require("../types");
const components_4 = require("./components");
const helpers_1 = require("./helpers");
//This is to hide the scrollbar in Firefox
const StorageWidgetWrapper = styled_components_1.default(components_1.StackView).attrs({
    direction: components_1.STACK_DIRECTION.column,
    align: components_1.STACK_ALIGN.center,
    gap: components_1.STACK_GAP.m,
}) `
  overflow: hidden;
`;
const StorageWidget = ({ isLoading, data, chartsData = [], total, totalLabel, totalDifference, totalSuffix, }) => {
    return isLoading ? (react_1.default.createElement(components_2.WidgetSpinner, null)) : (react_1.default.createElement(StorageWidgetWrapper, null,
        react_1.default.createElement(components_4.StorageUsageIconRow, { data: data }),
        react_1.default.createElement(components_1.StackView, { borderTop: components_1.VIEW_BORDER.normal, spaceFill: components_1.SPACE_FILL.all, indentHorizontal: components_1.INDENT.xl }),
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, gap: components_1.STACK_GAP.l },
            react_1.default.createElement(Charts_1.CircularChart, { value: helpers_1.getNormalizedSizes(chartsData), total: total, totalLabel: totalLabel, totalDifference: totalDifference, totalSuffix: totalSuffix, legendType: Charts_1.CHART_LEGEND_TYPE.total, scale: 2.66, isTrendHidden: true }),
            react_1.default.createElement(components_3.ChartLegend, { data: chartsData }))));
};
exports.StorageWidget = StorageWidget;
//# sourceMappingURL=StorageWidget.js.map